document.addEventListener('DOMContentLoaded', ()=>{
    // 1. Sync link 'href' to match the live image 'src' generated by Parcel
    document.querySelectorAll('.gallery-item').forEach((item)=>{
        const img = item.querySelector('img');
        if (img) item.setAttribute('href', img.src);
    });
    // 2. Initialize GLightbox
    let lightbox = GLightbox({
        selector: '.glightbox:not(.hide)',
        touchNavigation: true,
        loop: true,
        zoomable: true
    });
    // 3. Category Filtering Logic
    const filterButtons = document.querySelectorAll('.filter-btn');
    const galleryItems = document.querySelectorAll('.gallery-item');
    filterButtons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            // Toggle active button style
            filterButtons.forEach((btn)=>btn.classList.remove('active'));
            button.classList.add('active');
            const filterValue = button.getAttribute('data-filter');
            // Show or Hide Items based on selected Category
            galleryItems.forEach((item)=>{
                const itemCategory = item.getAttribute('data-category');
                if (filterValue === 'all' || filterValue === itemCategory) item.classList.remove('hide');
                else item.classList.add('hide');
            });
            // Reload Lightbox for visible images
            lightbox.destroy();
            lightbox = GLightbox({
                selector: '.glightbox:not(.hide)',
                touchNavigation: true,
                loop: true,
                zoomable: true
            });
        });
    });
});

//# sourceMappingURL=repo.6147a557.js.map
